import { Box, Card, CardContent, Typography, Stack } from '@mui/material';
import Page from '../components/Page';
import PropTypes from 'prop-types';
import { useAuth } from '../contexts/AuthContext';

const InfoRow = ({ label, value }) => (
  <Stack direction="row" spacing={2} alignItems="center">
    <Typography
      variant="subtitle2"
      color="text.secondary"
      sx={{ minWidth: 140 }}
    >
      {label}
    </Typography>
    <Typography variant="body1">{value || '—'}</Typography>
  </Stack>
);

InfoRow.propTypes = {
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
};

const ProfilePage = () => {
  const { user, userType } = useAuth();

  return (
    <Page maxWidth="sm">
      <Box sx={{ mt: 4 }}>
        <Typography variant="h4" gutterBottom align="center">
          Profile
        </Typography>

        <Card>
          <CardContent>
            <Stack spacing={2}>
              <InfoRow label="User Type" value={userType} />
              <InfoRow label="Email" value={user?.email} />
              <InfoRow label="User ID" value={user?.id} />
            </Stack>
            <Typography
              variant="caption"
              color="text.secondary"
              display="block"
              sx={{ mt: 2 }}
            >
              Only non-sensitive login details are shown here.
            </Typography>
          </CardContent>
        </Card>
      </Box>
    </Page>
  );
};

export default ProfilePage;
